/* csc-yt-lite.js — Speed fixes 2026-10-12.
   Click-to-play for the YouTube placeholders produced by snippets/csc-rte-optimise.liquid.
   The placeholder is a real link (works without JS); on click we swap in the
   youtube-nocookie player with autoplay, keeping the same box size. */
(function () {
  function play(a) {
    var id = a.getAttribute('data-csc-yt');
    if (!id) return;
    var f = document.createElement('iframe');
    f.className = 'csc-yt__frame';
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    f.width = parseInt(a.style.width, 10) || 560;
    f.height = parseInt(a.style.height, 10) || 315;
    f.style.width = a.style.width || '560px';
    f.style.height = a.style.height || '315px';
    f.style.maxWidth = '100%';
    f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('title', a.getAttribute('data-csc-yt-title') || 'YouTube video');
    a.parentNode.replaceChild(f, a);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a.csc-yt') : null;
    if (!a) return;
    e.preventDefault();
    play(a);
  });
})();
